// Pure helpers for the profile page. No React, no network.

const EDITABLE_FIELDS = ["fullName", "phone", "addressLine1", "addressLine2", "city", "state", "zip"];

/** Only the fields the profile form edits. Username, email and roles are never sent from here. */
export function editablePayload(details) {
  return EDITABLE_FIELDS.reduce((acc, key) => (key in details ? { ...acc, [key]: details[key] ?? "" } : acc), {});
}

/** Mirrors the backend PasswordPolicy. Returns a message for the first broken rule, or null. */
export function passwordViolation(password) {
  if (!password || password.length < 8) return "New password must be at least 8 characters.";
  if (!/[A-Z]/.test(password) || !/\d/.test(password) || !/[^A-Za-z0-9]/.test(password)) {
    return "New password must include an uppercase letter, a number and a symbol.";
  }
  return null;
}

export function initialsOf(name) {
  const words = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "U";
  const letters = words.length === 1 ? [words[0][0]] : [words[0][0], words[words.length - 1][0]];
  return letters.join("").toUpperCase();
}

export function addressLines(profile) {
  const p = profile || {};
  const lines = [p.addressLine1, p.addressLine2].filter(Boolean);
  const cityState = [p.city, p.state].filter(Boolean).join(", ");
  const tail = [cityState, p.zip].filter(Boolean).join(" ").trim();
  if (tail) lines.push(tail);
  return lines;
}

export function missingContactFields(profile) {
  const p = profile || {};
  const missing = [];
  if (!String(p.phone || "").trim()) missing.push("phone number");
  if (addressLines(p).length === 0) missing.push("primary residence");
  return missing;
}

export function roleLabels(roles) {
  const seen = new Set();
  (roles || []).forEach((r) => {
    const label = String(r)
      .replace(/^ROLE_/, "")
      .split("_")
      .filter(Boolean)
      .map((w) => w[0] + w.slice(1).toLowerCase())
      .join(" ");
    if (label) seen.add(label);
  });
  return Array.from(seen);
}

export function withNotificationToggle(prefs, topicId, channel, value) {
  return { ...prefs, [topicId]: { ...(prefs[topicId] || {}), [channel]: value } };
}
